import React, { useMemo } from 'react'
import '../Assets/Css/TableRow.scss'
import UserAvatar from "react-user-avatar";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import 'tippy.js/themes/light.css';
import { FiArrowDownLeft, FiArrowUpLeft, FiEye } from "react-icons/fi";
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../Lib/Init-firebase';
import { BiEditAlt } from 'react-icons/bi';
import { Link } from 'react-router-dom';
import { TiDelete } from 'react-icons/ti';



const TableRow = ({ key, data, index, header, setModelData, setShow, selectedId, checked, handleChange, totalSelectedIds, idsArray, showIsView = true }) => {

  const handleClick = () => {
    if (!data.id) {
      return null;
    }
    setModelData({
      name: data.Name.value,
      email: data.Email.value,
      phoneNumber: data['Phone Number'].value,
      subject: data.Subject.value,
      description: data.description.value,
    });
    setShow(true);
    const docRef = doc(db, 'users', data.id.value);
    updateDoc(docRef, { read: true }).then(response => { }).catch(error => { })
  };

  return (
    <tr className={`table-data-row ${((data?.Description?.value === '') || (data?.allPaymentDistributed === false)) ? 'bg-red' : ''}`} key={index} onClick={handleClick} >

      {header.map((col, index) => {

        if (data[col.field]) {
          switch (data[col.field].type) {
            case 'checkbox':
              return <td className="table-data-td" key={index}>
                {<input type="checkbox" checked={totalSelectedIds.find((id) => { return id == data[col.field].value }) ? true : false} id={data[col.field].value} name={`name${index}`} onChange={(e) => {
                  let event = [
                    e.target.checked,
                    e.target.id,
                    idsArray
                  ];
                  handleChange(event);
                }} />}
              </td>
            case 'total':
              return <td className="table-data-td" key={index} >
                <h6 className="total">{data[col.field].value}</h6>
              </td>
            case 'text':
              return <td className="table-data-td" key={index} >
                <h6 className="text">{data[col.field].value}</h6>
              </td>
            case 'amount':
              return <td className="table-data-td" key={index} >
                <h6 className="amount">{data[col.field].value}</h6>
              </td>
            case 'percentages':
              return <td className="table-data-td" key={index}>
                <h6 className="date">{data[col.field].value}</h6>
              </td>
            case 'client':
              return <td className="table-data-td" key={index}>
                <div className="client">
                  <div className="client-image">
                    <UserAvatar size='40' src={data[col.field].src} name={data[col.field].value} />
                  </div>
                  <div className="client-data">
                    <h6 className="highlight-text">{data[col.field].value}</h6>
                    <h6 className="small-text">{data[col.field].value2}</h6>
                  </div>
                </div>
                <div>
                  <h6 style={{ color: "rgb(119, 126, 137)", marginTop: "10px" }}>{data[col.field].title}</h6>
                </div>
              </td>
            case 'date':
              return <td className="table-data-td" key={index}>
                <h6 className="date">{data[col.field].value}</h6>
              </td>
            case 'share holder':
              if (data[col.field].value !== undefined) {
                return <td className="table-data-td" key={index}>
                  <div className="share-holder">
                    {
                      data[col.field]?.value?.slice(0, 3)?.map((sh, index) => {
                        return <div className='sh-img'>
                          <UserAvatar size='40' name={sh?.name} src={sh?.src} key={index} />
                        </div>
                      })
                    }
                    {
                      data[col.field].value.length >= 4 ? (
                        <div className='sh-img'>
                          {`+${data[col.field].value.length - 3}`}
                        </div>
                      ) : (null)
                    }
                  </div>
                </td>
              } else {
                return <td className='table-data-td' key={index}></td>
              }
            case 'status':
              return <td className="table-data-td" key={index}>
                <div className="status">
                  <div className={`status-circle ${data[col.field]?.value}`}></div>
                  <h6 className={`status-text ${data[col.field]?.value}`}>{data[col.field]?.value}</h6>
                </div>
              </td>
            case 'credit':
              return <td className="table-data-td" key={index}>
                <div className="credit">
                  <div className="credit-icon">

                    <FiArrowUpLeft />
                  </div>
                  <p className="credit-name">{data[col.field]?.value}</p>
                </div>
              </td>
            case 'debit':
              return <td className="table-data-td" key={index}>
                <div className="debit">
                  <div className="debit-icon">

                    <FiArrowDownLeft />
                  </div>
                  <p className="debit-name">{data[col.field].value}</p>
                </div>
              </td>
            case 'description':
              return <td className="table-data-td" key={index}>
                <h6 className="description">{data[col.field]?.value}</h6>
              </td>
            case "Rate":
              return <td className="table-data-td" key={index}>
                <h6 className="description">{data[col.field]?.value}</h6>
              </td>
            case "qty":
              return <td className="table-data-td" key={index}>
                <h6 className="description">{data[col.field]?.value}</h6>
              </td>
            case 'invoices':
              return <td className="table-data-td" key={index}>
                <Tippy theme={'light'}
                  content={
                    <ul style={{ listStyleType: 'none' }}>
                      {data[col.field]?.value?.map((invoice, index) => {
                        return <li key={index}>{invoice.id}</li>
                      })}
                    </ul>
                  }
                >
                  <h6 className="invoices">{data[col.field].value.map((no) => { return no.id })}</h6>
                </Tippy>
              </td>
            case 'action':
              return <td className='table-data-td' key={index}>
                <div className="actions">
                  <Link to={data[col.field].value} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}><BiEditAlt /></Link>
                  {
                    showIsView ? <Link to={data[col.field].value2} style={{ textDecoration: "inherit", color: "inherit" }} state={{ data: data }}><FiEye /></Link> : null
                  }

                </div>
              </td>
            case 'address':
              return <td className="table-data-td address-td" key={index}>
                <div className="address">
                  <p>{data[col.field].value}, {data[col.field].value2}, {data[col.field].state}, {data[col.field].country} - {data[col.field].postalcode}</p>
                </div>
              </td>
            case 'delete':
              return <td className='table-data-td' key={index}>
                <div className="delete-action">
                  <button className='delete-btn'><TiDelete /></button>
                </div>
              </td>
            default:
              return <td className="table-data-td" key={index}>

              </td>
          }
        } else {
          return <td className="table-data-td" key={index}></td>
        }
      })}
    </tr>
  )
}

export default TableRow
